import React from 'react'
import { connect } from 'react-redux'
import CartItem from './CartItem'
import CheckoutSection from './CheckoutSection'
import { deleteItemAsync, updateItemQuantityAsync, updateItemQuantity } from '../actions'

const CartList = ({ items, onQuantityChange, onDelete }) => {
  const cartItems = items.map((item) => {
    return (
      <CartItem
        key={item.Id}
        item={item}
        onQuantityChange={onQuantityChange}
        onDelete={onDelete}
      />
    );
  });
  return (
    <CheckoutSection label={'Shopping Cart'} hideBodyBorder={true}>
        {cartItems}
    </CheckoutSection>
  );
}

const cartListMapStateToProps = (state) => {
  return {
    items: state.entities.CartItems
  }
}

const cartListMapDispatchToProps = (dispatch) => {
  return {
    onQuantityChange: (id, value) => {
      dispatch(updateItemQuantityAsync({id, qty: value}));
    },
    onDelete: (id, prevQty) => {
      if ((typeof window !== 'undefined') && (typeof window.confirm !== 'undefined') && window.confirm("Delete this item?")) { 
        dispatch(deleteItemAsync({id}))
      } else {
        dispatch(updateItemQuantity(id, prevQty || 1))
      }
    }
  }
}

const CartListContainer = connect(cartListMapStateToProps, cartListMapDispatchToProps)(CartList);

export default CartListContainer
